import React from 'react';

import * as CoreComponents from '@amzn/monera-app-core-components/lib/components';

import * as DeviceSubsComponents from '../components';

export const componentsMap: Record<string, React.ComponentType<any>> = {
  //////////////////////////////////////
  // @amzn/monera-app-core-components //
  //////////////////////////////////////
  breadcrumbs: CoreComponents.Breadcrumbs,
  hero: CoreComponents.Hero,
  head: CoreComponents.CanvasContainer,
  redirector: DeviceSubsComponents.Redirector,
  'buy-now-buy-box': CoreComponents.BuyBox,
  'average-customer-reviews': CoreComponents.CustomerReviews,
  'average-customer-reviews-widget': CoreComponents.HtmlWidget,
  'html-widget': CoreComponents.HtmlWidget,
  'order-details': CoreComponents.OrderDetails,
  'product-description': CoreComponents.ProductDescription,
  'canvas-container': CoreComponents.CanvasContainer,
  'canvas-item': CoreComponents.CanvasItem,
  'customer-reviews-medley': CoreComponents.HtmlWidget,
  'product-price': CoreComponents.ProductPrice,
  'product-image': CoreComponents.ProductImage,
  'product-contributors': CoreComponents.ProductContributors,
  'product-title': CoreComponents.ProductTitle,
  'product-information': CoreComponents.ProductInformation,
  'product-feature-bullets': CoreComponents.ProductFeatureBullets,
  'meta-tag': CoreComponents.MetaTag,
  'order-confirmation': CoreComponents.OrderConfirmation,
  divider: CoreComponents.Divider,
  'order-confirmation-details': CoreComponents.OrderConfirmationDetails,
  'order-fulfillment': CoreComponents.OrderFulfillment,
  'hero-banner': CoreComponents.Media,
  'media-carousel': CoreComponents.MediaCarousel,
  'product-twister-desktop': CoreComponents.DesktopProductTwister,
  'device-subs-twister-plus': CoreComponents.ProductTwisterPlus,
  unavailability: CoreComponents.Alert,
  'device-subs-buy-box': CoreComponents.SubsBuyBox,
  'atf-marker': CoreComponents.AtfMarker,
  'btf-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'atf-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'atf-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'atf-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-4-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-5-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-6-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-7-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-8-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-9-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-10-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-4-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-5-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-6-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-7-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-8-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-9-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-10-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  loading: CoreComponents.Loading,
  'variation-context-container': CoreComponents.VariationContextContainer,
  //////////////////////////////////////
  // device subscription components //
  //////////////////////////////////////
  'aui-container': DeviceSubsComponents.AuiContainer,
  'aui-sub-header': DeviceSubsComponents.AuiSubHeader,
  'buybox-data-CS-slot': DeviceSubsComponents.EmptyComponent,
  'blockedbuybox-data-CS-slot': DeviceSubsComponents.EmptyComponent,
  data: DeviceSubsComponents.EmptyComponent,
  'twister-buybox': DeviceSubsComponents.TwisterBuyBox,
  'twister-data-CS-slot': DeviceSubsComponents.EmptyComponent,
  'custom-script': DeviceSubsComponents.CustomScriptComponent,
  'custom-script-CS-slot': DeviceSubsComponents.EmptyComponent,
  'blocked-buybox-container': DeviceSubsComponents.BlockedBuyboxContainer,
  'device-subs-meta-tag': CoreComponents.MetaTag,
  'device-subs-seo-meta-tag': DeviceSubsComponents.SeoMetaTag,
  'alt-buybox-container': DeviceSubsComponents.AltBuyboxContainer,
  'atf-top-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'atf-top-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'atf-top-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-11-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-12-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-13-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-14-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-15-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-16-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-17-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-18-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-19-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-20-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-21-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'btf-22-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'alt-buybox-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'alt-buybox-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'alt-buybox-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'alt-buybox-4-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-top-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-top-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-atf-top-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-11-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-12-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-13-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-14-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-15-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-16-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-17-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-18-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-19-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-20-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-21-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-btf-22-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-alt-buybox-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-alt-buybox-2-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-alt-buybox-3-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-alt-buybox-4-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'mobile-alt-buybox-restricted-mshop-1-CS-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget,
  'dynamic-symphony-slot': DeviceSubsComponents.DeviceSubsServerRenderedHtmlWidget
};
